import React from 'react';
import './block-with-n-items.scss';

function BlockWithNItems({ children, items = [] }) {
  return (
    <div className='block-with-n-items margin-bottom-wrapper wrapper-fluid'>
      <div className={`list-with-${items.length}-items`}>
        {items.map(content => React.cloneElement(children, { content }))}
      </div>
    </div>
  );
}

export default BlockWithNItems;
